<template>
  <div class="">
     <v-row>
      <v-col cols="12" md="6">
        <div class="d-flex justify-start">
          <router-link to="/polls">
            <v-icon color="#00AAD3"> mdi-arrow-left-thin </v-icon>
            <span class="color-primary mt-1">Back </span>
          </router-link>
        </div>
      </v-col>
     </v-row>
   
      <v-row>
        <v-col cols="12" md="9">
          <span class="heading-1" >Questionnaires and Surveys</span>
          <div class="mt-12">
            <span class="font-26"
              >Q-1 Take our free Fundamentally BodyTalk course
            </span>
            <v-container fluid>
              <v-radio-group v-model="radios">
                <v-radio value="Option1">
                  <template v-slot:label>
                    <div class="font-20 pl-2">Option 1</div>
                  </template>
                </v-radio>
                <v-radio value="Option2">
                  <template v-slot:label>
                    <div class="font-20 pl-2 mt-2">Option 1</div>
                  </template>
                </v-radio>
                <v-radio value="Option3">
                  <template v-slot:label>
                    <div class="font-20 pl-2 mt-2">Option 1</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-container>
          </div>
          <div>
            <span class="font-26"
              >Q-2 Take our free Fundamentally BodyTalk course
            </span>
            <v-container>
              <v-checkbox v-model="checkbox" class="mt-0 mb-0">
                <template v-slot:label >
                  <div class="font-20">Option 1</div>
                </template>
              </v-checkbox>
              <v-checkbox v-model="checkbox1" class="mt-0 mb-0">
                <template v-slot:label>
                  <div class="font-20">Option 1</div>
                </template>
              </v-checkbox>
              <v-checkbox v-model="checkbox2" class="mt-0 mb-0">
                <template v-slot:label>
                  <div class="font-20">Option 1</div>
                </template>
              </v-checkbox>
            </v-container>
          
          </div>

          <div class="">
            <span class="font-26"
              >Q-3 Take our free Fundamentally BodyTalk course
            </span>
            <v-container fluid class="mt-0">
              <v-radio-group v-model="radioscourse" class="small-radio mt-0">
                <v-row>
                  <v-col cols="12" sm="2" md="2">
                    <span class="font-14 d-flex justify-center">1</span>
                    <v-radio
                      style="font-size: none"
                      class="mt-10 d-flex justify-center"
                      label=""
                      large
                      value="radio-1"
                    ></v-radio>
                    <span class="font-16 d-flex justify-center mt-6"
                      >Terrible
                    </span>
                  </v-col>
                  <v-col cols="12" sm="2" md="2">
                    <span class="font-14 d-flex justify-center">2</span>
                    <v-radio
                      class="mt-10 d-flex justify-center v-icons"
                      label=""
                      value="radio-2"
                    ></v-radio>
                    <span class="font-16 d-flex justify-center mt-6">Bad </span>
                  </v-col>
                  <v-col cols="12" sm="2" md="2">
                    <span class="font-14 d-flex justify-center">3</span>
                    <v-radio
                      class="mt-10 d-flex justify-center"
                      label=""
                      value="radio-3"
                      style="font-size: 38px !important"
                    ></v-radio>
                    <span class="font-16 d-flex justify-center mt-6"
                      >Okay
                    </span>
                  </v-col>
                  <v-col cols="12" sm="2" md="2">
                    <span class="font-14 d-flex justify-center">4</span>
                    <v-radio
                      class="mt-10 d-flex justify-center"
                      label=""
                      value="radio-4"
                    ></v-radio>
                    <span class="font-16 d-flex justify-center mt-6"
                      >Good
                    </span>
                  </v-col>
                  <v-col cols="12" sm="2" md="2">
                    <span class="font-14 d-flex justify-center">5</span>
                    <v-radio
                      class="mt-10 d-flex justify-center v-icon"
                      label=""
                      value="radio-5"
                    ></v-radio>
                    <span class="font-16 d-flex justify-center mt-6"
                      >Great
                    </span>
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-container>
          </div>
          
       
        </v-col>
    
      </v-row>
  
  </div>
</template>

<script>

export default {
  name: "dashboard",

  data() {
    return {
      takesurveyForm: [],
      BtnLoader: false,
      valuecheck: {
        radios: "",
        radioschart: "",
        radioscourse: "",
        checkbox: "",
        checkbox1: "",
        checkbox2: "",
      },
      power: 78,
      items: [
        { text: "Name", icon: "xx/xx", value: "70", color: "#147AD6" },
        { text: "Name", icon: "xx/xx", value: "30", color: "#EC6666" },
        { text: "Name", icon: "xx/xx", value: "80", color: "#79D2DE" },
      ],
    };
  },
  methods: {
    submitSurvey() {
      this.takesurveyForm.push(this.valuecheck);
      
      this.BtnLoader = true;

      setTimeout(() => {
        this.BtnLoader = false;
        this.$swal.fire({
          width: 600,
          padding: "3em",
          icon: "success",
          html: "<p style='font-size:22px'><b> Thank you. You have already taken this survey. Surveys responses cannot be entered twice.</b></p> ",
          showConfirmButton: false,
          timer: 3000,
        });
      }, 3000);
    },
  },
};
</script>
